import axiosClient from "../../network";

export default class authenticationService {
  static async walletConnectLogin(payload) {
    try {
      const { data } = await axiosClient.post(
        "/user/walletConnect/login",
        payload
      );
      return data;
    } catch (error) {
      if (error.data) {
        return { error: error.data };
      }
      return {
        error,
      };
    }
  }

  static async refreshLogin() {
    try {
      const data = await axiosClient.get("/user/refreshToken");
      return data;
    } catch (error) {
      if (error.data) {
        return { error: error.data };
      }
      return {
        error,
      };
    }
  }

  static async verifyEmail(payload) {
    try {
      const { data } = await axiosClient.post("/user/verifyEmail", payload);
      return data;
    } catch (error) {
      if (error.data) {
        return { error: error.data };
      }
      return {
        error,
      };
    }
  }

  static async verifyPasswordToken(payload) {
    try {
      const { data } = await axiosClient.post(
        "/user/verifyPasswordToken",
        payload
      );
      return data;
    } catch (error) {
      if (error.data) {
        return { error: error.data };
      }
      return {
        error,
      };
    }
  }

  static async forgotPassword(payload) {
    try {
      const { data } = await axiosClient.post("/user/forgotPassword", payload);
      return data;
    } catch (error) {
      if (error.data) {
        return { error: error.data };
      }
      return {
        error,
      };
    }
  }

  static async getMetamaskUser(payload) {
    try {
      const { data } = await axiosClient.post(
        "/user/metamask/getNonce",
        payload
      );
      return data;
    } catch (error) {
      if (error.data) {
        return { error: error.data };
      }
      return {
        error,
      };
    }
  }

  static async verifyMetamaskSignature(payload) {
    try {
      const { data } = await axiosClient.post(
        "/user/metamask/verifySignature",
        payload
      );
      return data;
    } catch (error) {
      if (error.data) {
        return { error: error.data };
      }
      return {
        error,
      };
    }
  }
}
